import{createContext as a}from"react";var e=a({mapping:[],parsedData:[],indexes:{min:0,max:0,keys:{}}});export{e as default};
